// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copy-button{position:relative;top:-1px}.copy-button .v-btn{color:#bdbdbd;height:20px;margin:0 4px;transition:none;width:20px}.copy-button .v-btn:before{transition:none}.copy-button .v-btn:hover{color:#757575}.copy-button .v-btn:focus:before,.copy-button .v-btn:hover:before{background-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
